@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Energimerker</h2>

    <div class="expander energylabels" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <div class="left">
                <ul>
                    @for (energyLabel of this.filterForm().energyLabels; track $index) {
                        <li class="check-box" (click)="toggleSelectedEnergyLabel(energyLabel().value())">
                            <div class="estate-icon {{ energyLabel.energyLabel().value().toString() }}"></div>
                            <input
                                type="checkbox"
                                class="checkbox-icon"
                                [formField]="energyLabel.selected"
                                [class.selected]="energyLabel.selected().value()"
                            />
                            <label>Energimerke {{ energyLabel.energyLabel().value().toString() }} </label>
                        </li>
                    }
                </ul>
            </div>
            <div class="right">
                <div class="select-all-btn" data-cy="click-all" (click)="selectAllEnergyLabels()">
                    <label>Alle</label>
                </div>
            </div>
        </div>
    </div>
}
